module.exports = {
      id: "video-icon-usage",
      viewBox: "0 0 92 92",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#video-icon",
      toString: function () {
        return this.url;
      }
    }